import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { RepeatedPrescriptionComponent } from './components/repeated-prescription/repeated-prescription.component';
import { ReceiptComponent } from './components/receipt/receipt.component';
import { HistoryComponent } from './components/order-dosage/history/history.component';
import { ReportHelperComponent } from './report-helper/report-helper.component';
import { RegisterComponent } from './components/register/register.component';
import { SamplingOrderListComponent } from './components/nhi/sampling-order-list/sampling-order-list.component';
import { ConsultationVoulmeComponent } from './components/consultation-volume/consultation-volume.component';
import { OrderDosageComponent } from './components/order-dosage/order-dosage.component';
import { DailyPaymentReportComponent } from './components/payment/daily-report/daily-payment-report.component';
import { ReportHistIndexComponent } from './components/declare/report-hist-index/report-hist-index.component';
import { DrugBagComponent } from './components/drug-bag/drug-bag.component';
import { HistoryCertificateComponent } from './components/hist-report/history-certificate/history-certificate.component';
import { CtrdrugsContainerComponent } from './components/ctrdrugs-container/ctrdrugs-container.component';
import { LabsOutclinicReportComponent } from './components/labs/labs-outclinic-report/labs-outclinic-report.component';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { HistoryListComponent } from './components/hist-report/history-list/history-list.component';
import { ReportHistPrintOriginalComponent } from './components/hist-report/report-hist-print-original/report-hist-print-original.component';
import { ReportHistPrintDiffpersonComponent } from './components/hist-report/report-hist-print-diffperson/report-hist-print-diffperson.component';
import { ArrearReceiptComponent } from './components/arrear-receipt/arrear-receipt.component';
import { RxdataReportContentComponent } from './components/rxdata-report-content/rxdata-report-content.component';
import { ToothPositionsMapComponent } from 'src/app/hist/tooth-positions-map/tooth-positions-map.component';
import { DiscountCodeComponent } from './components/discount-code/discount-code.component';
import { FirstFollowUpReportComponent } from './components/first-followUp-report/first-followUp-report.component';
import { VisitcountListComponent } from 'src/app/system/report/components/visitcount-list/visitcount-list.component';
import { DynamicReciptComponent } from './design-tools/dynamic-recipt/dynamic-recipt.component';
import { RegFreeFeeComponent } from './components/reg-free-fee/reg-free-fee.component';
import { InsuranceDeclarationReportComponent } from './components/insurance-declaration-report/insurance-declaration-report.component';
import { StatusFinishWithoutPrescriptionReportComponent } from './components/status-finish-without-prescription-report/status-finish-without-prescription-report.component';
import { RepeatedPrescriptionDynamicComponent } from './design-tools/repeated-prescription/repeated-pres-dynamic/repeated-pres-dynamic.component';
import { DailyReconReportBydateComponent } from 'src/app/system/report/components/daily-recon-report-bydate/daily-recon-report-bydate.component';
import { MonthScheduleReportComponent } from './components/schedule/month-schedule-report.component';
import { ScheduleReportComponent } from './components/schedule/schedule-report.component';
@NgModule({
  declarations: [
    RepeatedPrescriptionComponent,
    DrugBagComponent,
    ReceiptComponent,
    HistoryComponent,
    ReportHelperComponent,
    RegisterComponent,
    ReportHistIndexComponent,
    ConsultationVoulmeComponent,
    CtrdrugsContainerComponent,
    DailyPaymentReportComponent,
    OrderDosageComponent,
    SamplingOrderListComponent,
    HistoryCertificateComponent,
    RxdataReportContentComponent,
    LabsOutclinicReportComponent,
    HistoryListComponent,
    ReportHistPrintOriginalComponent,
    ReportHistPrintDiffpersonComponent,
    ArrearReceiptComponent,
    FirstFollowUpReportComponent,
    DiscountCodeComponent,
    VisitcountListComponent,
    DynamicReciptComponent,
    RepeatedPrescriptionDynamicComponent,
    RegFreeFeeComponent,
    ToothPositionsMapComponent,
    InsuranceDeclarationReportComponent,
    StatusFinishWithoutPrescriptionReportComponent,
    DailyReconReportBydateComponent,
    MonthScheduleReportComponent,
    ScheduleReportComponent,

  ],
  imports: [
    CommonModule,
    SharedModule,
    NgxBarcode6Module,
  ],
  exports: [
    ReportHelperComponent,
    ReportHistIndexComponent,
    ConsultationVoulmeComponent,
    DailyPaymentReportComponent,
    OrderDosageComponent,
    SamplingOrderListComponent,
    HistoryComponent,
    HistoryCertificateComponent,
    RxdataReportContentComponent,
    CtrdrugsContainerComponent,
    HistoryListComponent,
    DrugBagComponent,
    ReportHistPrintOriginalComponent,
    ReportHistPrintDiffpersonComponent,
    ArrearReceiptComponent,
    DiscountCodeComponent,
    FirstFollowUpReportComponent,
    VisitcountListComponent,
    DynamicReciptComponent,
    RepeatedPrescriptionDynamicComponent,
    RegFreeFeeComponent,
    ToothPositionsMapComponent,
    InsuranceDeclarationReportComponent,
    StatusFinishWithoutPrescriptionReportComponent,
    DailyReconReportBydateComponent,
    MonthScheduleReportComponent,
    ScheduleReportComponent,
  ]
})
export class ReportHelperModule { }
